import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import TooltipedImg from '../../../../components/Common/TooltipedImg';
import {selectField} from '../actions/Screen';
import {textConst, getLocalizedText, texts} from '../../../../constants/TextConst';
import {withElementRef, InjectedElementRefProps} from '../../../components/Fields/withElementRef';
import {withScrollOnMove} from '../../../components/Fields/withScrollOnMove';
import {InjectedCollapsibleFieldProps} from '../../../../components/Common/Collapsible/Field';
import {InjectedParentFieldProps} from '../../../../components/Common/Collapsible/Collection';
import packageHidden from '../../../../images/package_hidden.png';
import {isRTL} from '../../../../Localization';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';

interface Props {
    field: any;
}

@observer
export class Package extends Component<
    Props & InjectedCollapsibleFieldProps & InjectedElementRefProps,
    null
> {
    constructor(props) {
        super(props);
        this.selectField = this.selectField.bind(this);
    }

    selectField(e) {
        const {field} = this.props;
        selectField(field);
    }

    renderHiddenImage() {
        const {field} = this.props;

        return field.hidden ? (
            <div className="images">
                <TooltipedImg
                    componentClasses="hidden-package-image"
                    src={packageHidden}
                    alt={textConst.hiddenSignAlt}
                    tooltipText={getLocalizedText(texts.hiddenPack)}
                    height={50}
                    position="right"
                    turn
                />
            </div>
        ) : null;
    }

    render() {
        const {field, depth} = this.props;
        const fieldClass = classNames('field', {
            selected: field.isSelected,
            hidden: field.hidden
        });
        const depthStyle = {
            marginRight: `${depth * 30}px`
        };

        return (
            <div className={fieldClass} onClick={this.selectField} ref={this.props.elementRef}>
                <div style={depthStyle}></div>
                <span title={field.title}>{field.title}</span>
                {this.renderHiddenImage()}
            </div>
        );
    }
}

const ExtendedPackageField = withElementRef(withScrollOnMove(Package));
export const PackageField = props => <ExtendedPackageField {...props} />;

@observer
class PackageCategory extends Component<Props & InjectedParentFieldProps, null> {
    constructor(props) {
        super(props);

        this.selectField = this.selectField.bind(this);
    }

    selectField() {
        const {toggleExpanded, field} = this.props;
        //don't open tab on select if it happens during title editing
        toggleExpanded();
        selectField(field);
    }

    render() {
        const {field, isExpanded} = this.props;
        const {marked, sum} = field;
        const tabClass = classNames('field tab', {
            expanded: isExpanded,
            selected: field.isSelected
        });
        return (
            <div className={tabClass} onClick={this.selectField}>
                <Icon
                    icon={
                        isExpanded
                            ? PriorityIcon.arrowBottom
                            : isRTL()
                            ? PriorityIcon.arrowLeft
                            : PriorityIcon.arrowRight
                    }
                />
                <div className="tab-content">
                    <span title={field.title}>{field.title}</span>
                </div>
                <div className="active-count">
                    <span>
                        {sum} / {marked}
                    </span>
                </div>
            </div>
        );
    }
}

export const PackageCategoryField = props => <PackageCategory {...props} />;
